import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { X } from "@phosphor-icons/react";
import PasswordInput from "@/components/PasswordInput";

export default function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw !== pw2) { setErr("Passwords do not match."); return; }
    if (pw.length < 8) { setErr("New password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: pw });
      toast.success("Password updated.");
      onClose?.();
    } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 bg-slate-900/60 flex items-center justify-center p-4 z-50" data-testid="change-password-modal">
      <form onSubmit={submit} className="bg-white rounded-md w-full max-w-md p-6 border border-slate-200 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold">Change password</h2>
          <button type="button" onClick={onClose} className="text-slate-500 hover:text-slate-800"><X size={20} /></button>
        </div>
        <label className="text-xs font-bold uppercase tracking-widest text-slate-500">Current password</label>
        <PasswordInput required value={current} onChange={(e) => setCurrent(e.target.value)}
               data-testid="cp-current" autoComplete="current-password" wrapperClassName="mt-1"
               className="w-full h-11 px-3 border border-slate-300 rounded-md" />
        <label className="text-xs font-bold uppercase tracking-widest text-slate-500 mt-4 block">New password</label>
        <PasswordInput required value={pw} onChange={(e) => setPw(e.target.value)}
               data-testid="cp-new" autoComplete="new-password" wrapperClassName="mt-1"
               className="w-full h-11 px-3 border border-slate-300 rounded-md" />
        <label className="text-xs font-bold uppercase tracking-widest text-slate-500 mt-4 block">Confirm new password</label>
        <PasswordInput required value={pw2} onChange={(e) => setPw2(e.target.value)}
               data-testid="cp-confirm" autoComplete="new-password" wrapperClassName="mt-1"
               className="w-full h-11 px-3 border border-slate-300 rounded-md" />
        {err && <div className="text-red-600 text-sm mt-3">{err}</div>}
        <div className="mt-6 flex gap-3 justify-end">
          <button type="button" onClick={onClose} className="h-11 px-4 border border-slate-300 rounded-md font-semibold hover:bg-slate-50">Cancel</button>
          <button data-testid="cp-submit" disabled={busy} className="h-11 px-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-md disabled:opacity-60">
            {busy ? "Updating…" : "Update password"}
          </button>
        </div>
      </form>
    </div>
  );
}
